import PropTypes from 'prop-types'
import React from 'react'
import { Button } from '@adc/ui-core'
import { onLogoutHandler } from '../../util/logout'

const LogoutButton = ({ children = 'Log Out', ...rest }) => (
  <Button onClick={onLogoutHandler} {...rest}>
    {children}
  </Button>
)

LogoutButton.propTypes = {
  children: PropTypes.node,
}

export default LogoutButton
